module.exports = __webpack_public_path__ + "static/obchodne-podmienky-adcebda2b2452a2f893ca06ca2d3e5fe.pdf";